import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import AuthCallback from "@/pages/AuthCallback";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import StudentDashboard from "@/pages/StudentDashboard";
import { Loader2 } from "lucide-react";

const FullLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#090D16]">
    <Loader2 className="w-8 h-8 text-emerald-500 animate-spin" />
  </div>
);

function RootGate() {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!user) return <Login />;
  if (user.role === "student") return <Navigate to="/student" replace />;
  return <Navigate to="/admin" replace />;
}

function Protected({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === "student" ? "/student" : "/admin"} replace />;
  }
  return children;
}

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<RootGate />} />
      <Route
        path="/admin"
        element={
          <Protected roles={["admin", "super_admin"]}>
            <AdminDashboard />
          </Protected>
        }
      />
      <Route
        path="/student"
        element={
          <Protected roles={["student"]}>
            <StudentDashboard />
          </Protected>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" theme="dark" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
